import { hoc } from '#packages/util';
import React, { type FC } from 'react';
import { withRestrictions } from '#packages/editorRestrictions';
import GridLines from './gridLines';
import { mapStateToProps } from './gridLinesMapper';
import { createSelector } from '../../selectors/selector';
import { editorAPISel } from '../selectors/rootSelectors';
import { FixedStageApiKey, AnimationsApiKey } from '#packages/apis';
import styles from './gridLines.scss';

import type { GridLinesContainerProps } from './types';

const GridLinesContainer: FC<GridLinesContainerProps> = ({
  isVisible,
  showContainerGridLines,
  isFade,
  containerGridLines,
  pageGridLines,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div key="gridLines" className={styles.gridLines}>
      <GridLines
        key="pageGridLines"
        dataHook="pageGridLines"
        gridLines={pageGridLines}
        fade={isFade}
      />

      {showContainerGridLines ? (
        <GridLines
          key="containerGridLines"
          dataHook="containerGridLines"
          gridLines={containerGridLines}
        />
      ) : null}
    </div>
  );
};

export const shouldShowGridLinesContainer = createSelector(
  [editorAPISel],
  (editorAPI) =>
    !editorAPI.zoomMode.isStageZoomMode() &&
    !editorAPI.host.getAPI(FixedStageApiKey).isStageFixedInDesktop() &&
    !editorAPI.host.getAPI(AnimationsApiKey).isInScrubPreview(),
);

export default withRestrictions('rEditor_gridlines-container')(
  hoc.withConditionalRender(
    hoc.STORES.MOUSE_OPS,
    shouldShowGridLinesContainer,
  )(hoc.connect(hoc.STORES.MOUSE_OPS, mapStateToProps)(GridLinesContainer)),
);
